"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAmplifyContext = exports.AMPLIFY_CONTEXT_BRAND = exports.withTokens = exports.createMockAmplifyContext = void 0;
/*
This file maps exports from `@aws-amplify/core/internals/testing`. These are
shared TEST-ONLY helpers (they rely on the ambient `jest` global) for use by
the other Amplify packages' unit tests. Never import this entry from runtime
library code.
*/
var createMockAmplifyContext_1 = require("./createMockAmplifyContext");
Object.defineProperty(exports, "createMockAmplifyContext", { enumerable: true, get: function () { return createMockAmplifyContext_1.createMockAmplifyContext; } });
Object.defineProperty(exports, "withTokens", { enumerable: true, get: function () { return createMockAmplifyContext_1.withTokens; } });
// Re-exports for one-stop test imports.
var contextBrand_1 = require("../context/contextBrand");
Object.defineProperty(exports, "AMPLIFY_CONTEXT_BRAND", { enumerable: true, get: function () { return contextBrand_1.AMPLIFY_CONTEXT_BRAND; } });
Object.defineProperty(exports, "isAmplifyContext", { enumerable: true, get: function () { return contextBrand_1.isAmplifyContext; } });
